'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var ItemCard = require('../../components/ItemCard/ItemCard.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var helper = require('../ItemSelector/helper.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ShopNowItems = _ref => {
  let {
    itemDisplay,
    shopNowItems,
    locale,
    includeCurrency
  } = _ref;
  const {
    rawValue: skuLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoskuLabel'
  });
  const {
    rawValue: qtyLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoqtyLabel'
  });
  const {
    rawValue: colorLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfocolorLabel'
  });
  const {
    rawValue: sizeLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfosizeLabel'
  });
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, shopNowItems.map(item => {
    return /*#__PURE__*/React__default["default"].createElement(ItemCard.ItemCard, _extends__default["default"]({
      key: `${item.sku ?? ''}${item.itemId ?? ''}`
    }, helper.getItemProps({
      item
    }), {
      attributes: helper.getItemAttrs({
        locale,
        includeCurrency,
        item,
        itemDisplay,
        selectedQuantity: item === null || item === void 0 ? void 0 : item.quantity,
        labels: {
          skuLabel,
          qtyLabel,
          colorLabel,
          sizeLabel
        }
      }),
      hasShippingProtection: item.hasShippingProtection
    }));
  }));
};

exports.ShopNowItems = ShopNowItems;
